// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2pOnu","inputDescription":"styles_inputDescription__3colR"};